import React, { useMemo } from 'react';
import { MenuTitle } from '.';
import useUpdateCurrentClinic from 'shared/hooks/useUpdateCurrentClinic';
import useClinicUser from 'shared/hooks/useClinicUser';
import { useMobileMenuProvider, MobileMenuViews } from './MobileMenuProvider';
import { VerticalPadding } from 'shared/components/SidePanel/components/InvoicingPanel';
import { Heading, Button, Text, Box, Center, HStack, Spinner } from '@televet/kibble-ui';
import { ClinicAvatar } from 'shared/components/Avatars';

const ChangeClinicsView = (): JSX.Element => {
  const { setCurrentMobileMenuView } = useMobileMenuProvider();
  const { clinicUser, currentClinicId } = useClinicUser();

  const clinics = useMemo(() => clinicUser?.clinics, [clinicUser]);

  const { updateCurrentClinic, loading: isUpdatingClinic } = useUpdateCurrentClinic();

  const onClinicSelected = async (clinicId: string): Promise<void> => {
    await updateCurrentClinic(clinicId);
  };

  return (
    <div>
      <MenuTitle>
        <Button
          iconName="chevronLeft"
          variant="ghostNeutral"
          onClick={(): void => setCurrentMobileMenuView(MobileMenuViews.Root)}
        />
        <Heading size="lg">{MobileMenuViews.ChangeClinics}</Heading>
      </MenuTitle>
      {isUpdatingClinic ? (
        <Center px={12.5}>
          Updating Clinic
          <div>
            <VerticalPadding />
            <Spinner />
          </div>
        </Center>
      ) : (
        <Box overflowX="hidden" overflowY="scroll" my={3}>
          {clinics?.map((clinic) => {
            const clinicNameParts = clinic.name.split(' ');
            return (
              <HStack
                px={5}
                py={2}
                spacing={3}
                height={12}
                key={clinic.id}
                onClick={(): Promise<void> => onClinicSelected(clinic.id)}
                background={currentClinicId === clinic.id ? 'background.alpha' : 'background.default'}
              >
                <ClinicAvatar
                  clinicMember={{
                    id: clinic.id,
                    firstName: clinicNameParts[0],
                    lastName: clinicNameParts[1] || '',
                    profilePic: clinic.logo,
                    displayName: clinic.name,
                  }}
                  showTooltip={false}
                />
                <Text size="md" variant="subtle">
                  {clinic.name}
                </Text>
              </HStack>
            );
          })}
        </Box>
      )}
    </div>
  );
};

export default ChangeClinicsView;
